<template>
  <div>
    <section class="xlrclh">
      <img
        class="top-img"
        src="../../assets/imgs/chongzhou/2/title-bg.png"
        alt=""
      />
      <div class="technological-process">
        <div class="zcjj">
          <img
            class="top"
            style="height: 2.12rem"
            src="../../assets/imgs/chongzhou/1/title.png"
            alt=""
          />
          <div class="content">
            <div class="des">
              做优做强郊区新城整体功能，以更加积极、开放、有效的人才政策赋能产业建圈强链，促进重点产业领域高层次人才队伍发展壮大，推动产业链、创新链、人才链融合发展，高质量建设成都人才发展特色区。
            </div>
          </div>
        </div>
        <div class="sxcl">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/2/title-1.png"
            alt=""
          />
          <div class="content">
            适用于工商注册、税收登记和统计关系均在崇州的企业(不含民办非企业、市属国有投融资平台公司)及其引进的人才和团队。“新引进”是指本政策实施之日(含)后来崇并首次在崇缴纳社保。个别新引进顶尖人才及团队领衔的重大项目，可按照“一事一议”原则研究决定。
          </div>
        </div>
        <div class="sscl">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/1/title-2.png"
            alt=""
          />
          <div class="content">
            <div class="des">
              <span>1.实行产业人才分类认定。</span
              >明确要围绕重点产业链和用人主体需求，动态编制和发布重点产业领域高层次人才目录，健全完善五类人才评价标准及认定机制。
            </div>
            <div class="des">
              <span>2.加大人才专项资金投入。</span
              >落实省市关于“持续加大人才发展投入”要求，增强人才发展专项资金投入，新设人才创投基金。
            </div>
            <div class="des">
              <span>3.开通企业自主认定人才通道。</span
              >丰富人才发现途径和评价方式，面向贡献突出的企业，给予一定数量的第Ⅳ类人才举荐名额。
            </div>
            <div class="des">
              <span>4.加强产业中高端人才双创扶持。</span
              >面向重点产业领域，培育和扶持一批人才创业创新，优化改善人才队伍结构，储备省市重大人才计划人选。
            </div>

            <div class="des">
              <span>5.支持企业引进紧缺岗位人才。</span
              >对企业全职引才、柔性引才等给予奖励。
            </div>
            <div class="des">
              <span>6.支持企业激励培养重要岗位人才。</span
              >从企业高管人才专项奖励和企业培养人才费用补贴两个方面设置激励措施。
            </div>
            <div class="des">
              <span>7.支持企业建立博士后科研工作平台。</span
              >对企业新建博士后平台给予奖励的基础上，明确“每招收1名博士后，还要资助平台和博士后研究人员日常经费，以及博士后出站留崇工作给予再奖励”的叠加激励措施。
            </div>
            <div class="des">
              <span>8.鼓励产业人才提升学历技能。</span
              >对人才在学历、职称和职业资格上取得提升，以及获得上级技能赛事奖项、获评技术能手称号的，给予奖励。
            </div>
            <div class="des">
              <span>9.实施产业高层次人才安居工程。</span
              >推出Ⅰ至IV类人才可租购人才公寓，Ⅰ至Ⅴ类落户人才可享受购买商品房补贴，招商引资重大项目和总部企业员工租住产业园区配套住房减免租金等优惠举措。
            </div>
            <div class="des">
              <span>10.优化产业高层次人才综合服务。</span
              >分类分层为符合条件的人才提供子女优待入学、绿色就医、通勤补贴等服务。
            </div>
          </div>
        </div>
        <div class="sbcl">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/1/title-3.png"
            alt=""
          />
          <div class="content">
            <div class="des">
              <div class="item">
                <div class="line"></div>
                <div class="dot">1</div>
                企业经办人汇总申报资料，向所属园区或行业主管部门申报。
              </div>
              <div class="item">
                <div class="line"></div>
                <div class="dot">2</div>
                主办单位牵头组织复审，协办单位核验并反馈结果。
              </div>
              <div class="item">
                <div class="dot">3</div>
                市委人才工作领导小组全体会议/专题会议/办公室主任会议审议通过后，按程序拨付经费。（子女入学/就医优待/租购人才公寓/重大招引项目和总部企业申购人才公寓事项待复审通过后直接按程序办理）。
              </div>
            </div>
          </div>
        </div>
        <div class="contact">
          <img
            class="top"
            src="../../assets/imgs/chongzhou/1/title-4.png"
            alt=""
          />
          <div v-if="contact" class="content">
            <div class="number" style="padding-left: 2.5rem">
              <span class="label">政策咨询电话：</span>
              <div>
                <div><a href="tel:028-82215255">028-82215255</a></div>
                <div><a href="tel:028-82228953">028-82228953</a></div>

                <!-- <div
                  :key="index"
                  v-for="(
                    item, index
                  ) in contact.contacts[0].contactInformation.split(',')"
                >
                  <a href="tel:028-83221725">{{ item }}</a>
                </div> -->
              </div>
            </div>
            <div
              class="number"
              style="padding-left: 2.5rem; margin-top: 0.2rem"
            ></div>
            <div>咨询单位：崇州市委人才办</div>
            <!-- <div>咨询单位：{{ contact.contacts[0].responsibleUnit }}</div> -->
          </div>
        </div>
        <div class="codes">
          <img class="code" src="../../assets/imgs/chongzhou/2/code.png" />
          <!-- <img class="text" src="../../assets/imgs/chongzhou/1/text.png" /> -->
        </div>
      </div>
    </section>
    <!-- <NewCall v-if="contact" :obj="contact"></NewCall> -->
  </div>
</template>

<script>
import NewCall from "../../components/NewCall.vue";
export default {
  data() {
    return {
      contact: null,
    };
  },

  components: {
    NewCall,
  },

  async mounted() {
    const { data } = await this.$policy(93);
    this.contact = data;
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
  background-color: $base-back;

  .top-img {
    width: 7.26rem;
  }

  .technological-process {
    transform: translateY(-1.8rem);

    .sscl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #d4e0ff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.4rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .title {
          font-size: 0.36rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.22rem;
          position: relative;
          span {
            font-weight: 600;
          }
        }
      }
    }

    .zcjj {
      // background-color:#fff;
      .top {
        width: 6.68rem;
        height: 2.12rem;
      }

      .content {
        width: 6.68rem;
        background: #ffffff;
        margin: -0.45rem auto 0;
        padding: 0.1rem 0.33rem 0.24rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        line-height: 0.44rem;

        .title {
          font-size: 0.34rem;
          font-weight: bold;
          color: #333333;
          text-align: left;
          line-height: 0.5rem;
        }

        .des {
          font-size: 0.26rem;
          color: #4e4e4e;
          text-align: left;
          margin-top: 0.16rem;
        }
      }
    }

    .sxcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #fff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        line-height: 0.44rem;
      }
    }

    .zccl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.8rem;
          position: relative;
          text-align: center;

          .title {
            position: absolute;
            top: -0.5rem;
            left: 50%;
            transform: translateX(-50%);
            width: 2.98rem;
            height: 0.67rem;
            line-height: 0.67rem;
            display: flex;
            justify-content: center;
            align-content: center;
            font-size: 0.32rem;
            font-weight: bold;
            color: #ffffff;
            border-radius: 1rem;
            background-color: #739bfe;
          }
        }
      }
    }

    .sbcl {
      position: relative;
      margin-top: 0.22rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #e8eeff;
        margin: -0.45rem auto 0;
        padding: 0 0.33rem 0.64rem 0.36rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;
        font-size: 0.26rem;
        font-weight: 500;
        text-align: left;
        color: #4e4e4e;
        font-size: 0.26rem;

        .des {
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          padding-top: 0.1rem;
          margin-top: 0.2rem;
          position: relative;

          .item {
            margin-top: 0.35rem;
            box-sizing: border-box;
            position: relative;
            padding-left: 0.42rem;
            display: flex;
            line-height: 0.44rem;
            .line {
              position: absolute;
              width: 0.02rem;
              height: 135%;
              border-left: 0.02rem dashed #739bfe;
              left: 0.1rem;
              top: 0.2rem;
              z-index: 0;
              //   background-color: #739bfe;
            }

            .dot {
              width: 0.39rem;
              height: 0.39rem;
              background-color: #739bfe;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.28rem;
              color: #fff;
              border-radius: 50%;
              position: absolute;
              left: -0.1rem;
              top: 0;
              z-index: 9999;
            }
          }
        }
      }
    }

    .codes {
      margin: 0 auto;
      margin-top: 0.25rem;
      width: 6.85rem;
      background: #fff;
      padding: 0.3rem;
      box-sizing: border-box;
      border-radius: 0.26rem;
      padding-top: 0.28rem;
      font-size: 0.26rem;
      font-weight: 500;
      color: #4e4e4e;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code {
        width: 6.19rem;
      }

      .text {
        width: 4rem;
      }
    }
  }
}
</style>
